import * as React from "react";
import { NavLink } from 'react-router-dom';
import MediaQuery from "react-responsive";
import { InverseDropdown } from "./styles"

interface IProps {
    firstName: string,
    lastName: string,
    username: string,
    currentUrl: string
}

class MicrositeCoachMenus extends React.Component<IProps, {}> {
    render = () => {
        return (
            <>
                <MediaQuery minWidth={1112}>
                    <div className="nkr-menu">
                        <div className='navbar navbar-inverse' style={{ borderRadius: 0, marginBottom: 10 }}>
                            <div className='navbar-header'>
                                <button type='button' className='navbar-toggle' data-toggle='collapse' data-target='.navbar-collapse' style={{ marginTop: 1, height: 18, padding: "5px 18px" }}>
                                    <span className='sr-only'>Toggle navigation</span>
                                    <span className='icon-bar'></span>
                                    <span className='icon-bar'></span>
                                    <span className='icon-bar'></span>
                                </button>
                            </div>
                            <div className='navbar-collapse collapse'>
                                <ul className='nav navbar-nav'>
                                    <li>
                                        <a href={'/microsite/coach'}>Microsite Patients</a>
                                    </li>
                                    <li>
                                        <a href={'/microsite/coach/report/microsite-coach-performance'}>Performance Report</a>
                                    </li>
                                    <li className="dropdown">
                                        <a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Welcome, {this.props.firstName} {this.props.lastName} <span className="caret"></span></a>
                                        <InverseDropdown className="dropdown-menu">
                                            <li>
                                                <NavLink to={'/manage-account'} activeClassName='active'>Manage Account</NavLink>
                                                <NavLink to={'/logout?next=' + this.props.currentUrl} activeClassName='active'>Logout</NavLink>
                                            </li>
                                        </InverseDropdown>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </MediaQuery>
            </>
        );
    }
}

export default MicrositeCoachMenus;